import React, {useEffect, useRef, useState} from 'react';
import classNames from "classnames";

import { ThumbsUp } from "../../../../assets/icons";

import './styles.scss';

interface ImageCardProps {
  option: string,
  isOptionSelected: boolean,
  handleOptionClick: ({ option }: {option: string}) => void;
  selectedIsCorrect: boolean;
  checkIsDone: boolean;
}

export const TrueFalseOption: React.FC<ImageCardProps> = ({
  option,
  isOptionSelected,
  handleOptionClick,
  selectedIsCorrect,
  checkIsDone,
}) => {
  return (
    <div
      className={classNames("AnswerOption", {
        "TrueOption": option === "true",
        "FalseOption": option === "false",
        "isSelected": isOptionSelected,
        "isCorrect": isOptionSelected && checkIsDone && selectedIsCorrect,
        "isIncorrect": isOptionSelected && checkIsDone && !(isOptionSelected && selectedIsCorrect),
      })}
      onClick={() => handleOptionClick({ option: "true" })}
    >
      <ThumbsUp className={classNames("Icon", {
        "ThumbsUp": option === "true",
        "ThumbsDown": option === "false",
      })}/>
    </div>
  )
};
